import React from "react"
import { Button, Container } from "react-bootstrap"
import { graphql, Link, useStaticQuery } from "gatsby"

const PillarBanner = ({ category }) => {
  const query = graphql`
    {
      allStrapiBlogs(
        filter: { isPillar: { eq: true } }
        sort: { fields: date, order: DESC }
      ) {
        group(field: category, limit: 1) {
          nodes {
            slug
            Image {
              localFile {
                publicURL
              }
            }
            title
            shortDescription
            category
            isPillar
          }
        }
      }
    }
  `

  const data = useStaticQuery(query)
  const {
    allStrapiBlogs: { group },
  } = data

  const catArr = group?.map(item => item.nodes).flat()

  const ans = catArr.filter(item => item.category === category)

  //   const {
  //     shortDescription,
  //     title,
  //     category,
  //     Image: {
  //       localFile: { publicURL },
  //     },
  //     slug,
  //   } = ans[0]

  return (
    <div className="pillar-banner">
      <section className="banner container">
        {ans[0] ? (
          <>
            <div className="hero-img-container2">
              <div className="color-overlay"></div>
              <img src={ans[0].Image.localFile.publicURL} alt={ans[0].title} />
            </div>
            <Container>
              <div className="banner-det2">
                <div className="banner-det">
                  <h2>{ans[0].title}</h2>
                  <p>{ans[0].shortDescription}</p>
                  <Link to={`/blog/${ans[0].category}/overview`}>
                    <Button variant="outline">Read More</Button>
                  </Link>
                </div>
              </div>
            </Container>
          </>
        ) : (
          <h1 className="text-center">No Pillar Post!</h1>
        )}
      </section>
    </div>
  )
}

export default PillarBanner
